import styled, { css } from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
export const CallToActionWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
  width: 100%;
  max-width: 965px;
  margin: 0 auto;

  ${mediaq.sm `
    flex-direction: column;
  `}
`;
export const CallToActionContainer = styled.div `
  padding: 36px;
  background-color: ${newColors.snow};
  border-radius: 18px;
  border: 1px solid ${newColors.gray100dot30};
  box-shadow: 0px 4px 26px 0px ${newColors.darkBlackAlpha};
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  min-height: ${({ twoColumns }) => (twoColumns ? '260' : '160')}px;
  ${mediaq.md `
  height: auto;
  `}
`;
export const CallToActionOuter = styled.div `
  display: flex;
  ${({ twoColumns }) => css `
    flex-direction: ${twoColumns ? 'column' : 'row'};
    align-items: ${twoColumns ? 'start' : 'center'};
    justify-content: space-between;
  `}
  height: 100%;
  gap: 16px;

  ${mediaq.md `
    gap: 20px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  `}
  ${mediaq.sm `
    gap: 14px;
  `}
`;
export const CallToActionInner = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;

  margin-left: ${({ twoColumns }) => (twoColumns ? '84px' : '0')};
  ${mediaq.md `
    margin-left: ${(props) => (props.twoColumns ? '0' : '56px')};
  `}

  ${mediaq.sm `margin-left: 0;`}
`;
export const CallToActionIcon = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  height: fit-content;
  flex-shrink: ${({ twoColumns }) => (twoColumns ? '0' : '1')};

  & > svg {
    flex-shrink: 0;
    width: 84px;
  }

  gap: ${({ twoColumns }) => (twoColumns ? '0' : '20px')};

  ${mediaq.md `
    gap: 10px;
    & > svg {
    width: 56px;
    }
  `}
  ${mediaq.sm `
    & > svg {
      flex-shrink: 0;
      width: 48px;
    }
  `}
`;
export const CallToActionInfo = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  gap: 10px;
`;
export const CallToActionHeader = styled.h2 `
  color: ${newColors.gray800};
  display: flex;
  flex-direction: ${({ twoColumns }) => (twoColumns ? 'column' : 'row')};
  gap: 0.25rem;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: 'Inria Serif';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  margin: 0;

  ${mediaq.md `
    font-size: 18px;
  `}

  ${mediaq.sm `
    flex-direction: column;
  `}
`;
export const CallToActionDescription = styled.p `
  color: ${newColors.gray800};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin: ${({ twoColumns }) => (twoColumns ? '16px 0 0 0' : '0')};
  width: ${({ twoColumns, isFullSize }) => (twoColumns ? '100' : (isFullSize ? '75' : '80'))}%;

  display: ${({ twoColumns, isMobile }) => (!twoColumns && !isMobile) || (twoColumns && isMobile) ? 'block' : 'none'};

  ${mediaq.md `
    width: 90%;
  `}
  ${mediaq.sm `
    display: ${({ isMobile }) => (!isMobile ? 'none' : 'block')};
    margin-top: 16px;
    width: 100%;
  `}
`;
export const CallToActionButton = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  background: ${newColors.purple500};
  color: ${newColors.snow};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  border: none;
  outline: none;
  padding: 8px 16px;
  height: 48px;
  width: 176px;
  border-radius: 9999px;
  &:hover {
    background-color: ${newColors.purple800};
  }
  margin-left: ${({ twoColumns }) => (twoColumns ? '84px' : '0')};
  ${mediaq.md `
    margin-left: ${(props) => (props.twoColumns ? '0' : '56px')};
  `}

  ${mediaq.sm `margin-left: 0;`}
`;
